export default __webpack_public_path__ + "static/media/instruments_dark.c3d3bccf.png";